import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';
import React, { useContext } from 'react';

import { UIContext } from '@uptime/shared/providers/UIProvider';

import useStyles from '../styles';
import { HeadCell } from '../types';

interface Props {
  rowCount?: number;
  onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRequestSort?: (id: string | number) => () => void;
  order: 'asc' | 'desc';
  orderBy?: string;
  headCells: (HeadCell & { sortId?: string })[];
  selectable?: boolean;
  tableTitle?: string;
}

const Head = (props: Props) => {
  const { order, orderBy, onRequestSort, headCells, selectable, rowCount, onSelectAllClick, tableTitle } =
    props;

  const classes = useStyles();

  const { selectableTable } = useContext(UIContext);

  const { option, include, exclude } = selectableTable;

  const isChecked =
    (option === 'all' && exclude.length === 0) ||
    (option === 'unselected' && include.length === (rowCount ?? 0));
  const isIndeterminate =
    (option === 'all' && exclude.length > 0 && exclude.length !== (rowCount ?? 0)) ||
    (option === 'unselected' && include.length > 0 && include.length < (rowCount ?? 0));

  return (
    <TableHead data-testid="tableHead">
      {tableTitle && (
        <TableRow className={classes.tableHeading}>
          <TableCell colSpan={3}>
            <Typography variant="h4" className={classes.tableTitle}>
              {tableTitle}
            </Typography>
          </TableCell>
        </TableRow>
      )}
      <TableRow>
        {selectable && (
          <TableCell>
            <Checkbox
              color="primary"
              onChange={onSelectAllClick}
              checked={isChecked}
              indeterminate={isIndeterminate}
            />
          </TableCell>
        )}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === (headCell.sortId ?? headCell.id) ? order : false}
            style={{ ...headCell.style, whiteSpace: 'nowrap' }}
          >
            {headCell.isSortable ? (
              <TableSortLabel
                active={orderBy === (headCell.sortId ?? headCell.id)}
                direction={order}
                onClick={onRequestSort?.(headCell.sortId ?? headCell.id)}
                IconComponent={ExpandMoreIcon}
              >
                {headCell.label}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default Head;
